import { TextField, makeStyles } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import DoneIcon from '@material-ui/icons/Done';

const useStyles = (value, error) =>
  makeStyles({
    root: {
      '& .MuiOutlinedInput-root.Mui-error': {
        '& fieldset': {
          borderColor: value
        }
      },
      '& .MuiOutlinedInput-notchedOutline': {
        color: value,
        borderColor: value,
        borderWidth: value === '#0d47a1' ? '2px' : '1px'
      },
      '& .MuiFormLabel-root.Mui-focused': {
        color: error ? value : '#0d47a1'
      },
      '& .Mui-error': {
        color: value
      },
      '& .MuiFormHelperText-root': {
        color: value
      },
      '& .MuiFormLabel-root': {
        color: value
      }
    }
  });

export default function Input(props) {
  const {
    name,
    label,
    value,
    placeholder,
    type = 'text',
    valid,
    error,
    onChange,
    onKeyUp,
    inputProps
  } = props;

  const colorValid = error
    ? 'rgba(0, 0, 0, 0.65)'
    : valid === undefined
    ? 'rgba(0, 0, 0, 0.65)'
    : valid
    ? '#0d47a1'
    : '';

  const classes = useStyles(colorValid, error)();

  return (
    <TextField
      variant='outlined'
      fullWidth
      name={name}
      label={label}
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onKeyUp={onKeyUp}
      error={error ? true : false}
      helperText={error}
      inputProps={inputProps}
      className={classes.root}
      style={{ marginBottom: '14px' }}
      InputProps={{
        endAdornment: error ? (
          <ErrorIcon style={{ color: 'rgba(0, 0, 0, 0.65)' }} />
        ) : valid ? (
          <DoneIcon color='primary' />
        ) : null
      }}
    />
  );
}
